import { forwardRefWithAs as f } from "@bedrock-layout/type-utils";
import m from "react";
function y(t) {
  return Array.isArray(t) && t.length === 2 && t.every(Number.isFinite) || typeof t == "string" && /^\d{1,1000} {0,1}\/ {0,1}\d{1,1000}$/.test(t);
}
function u(t) {
  return Array.isArray(t) ? t.join("/") : t;
}
function d(t) {
  return y(t) ? u(t) : void 0;
}
const R = f(
  ({ as: t, ratio: e, style: r, position: n, ...o }, i) => {
    const s = d(e), a = r ?? {}, c = t ?? "div";
    return /* @__PURE__ */ m.createElement(
      c,
      {
        "data-bedrock-frame": !0,
        ref: i,
        style: {
          ...a,
          "--ratio": s,
          "--position": n
        },
        ...o
      }
    );
  }
);
R.displayName = "Frame";
export {
  R as Frame
};
